
import React, { useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./Faq.css";

const FAQ = () => {

  const faqs = [
    {
      question: "What types of automotive glass do you manufacture?",
      answer:
        "We manufacture Automobile Toughened Glass, Automotive Toughened Glass, Tempered Glass, Laminated Glass, Railway Window Glass, and Commercial Vehicle Glass.",
    },
    {
      question: "Do you provide customized glass solutions?",
      answer:
        "Yes, we offer customized automotive glass solutions according to customer requirements and vehicle specifications.",
    },
    {
      question: "Where is Khodiyar Industries located?",
      answer:
        "Khodiyar Industries is located in Mehsana, Gujarat, India.",
    },
    {
      question: "Are your products quality tested?",
      answer:
        "Yes, all our products undergo strict quality checks to ensure durability, scratch resistance, and safety standards.",
    },
    {
      question: "Do you supply glass for commercial vehicles?",
      answer:
        "Yes, we provide premium-quality glass solutions for commercial vehicles, buses, and heavy-duty applications.",
    },
    {
      question: "How can I request a quote?",
      answer:
        "You can request a quote by visiting our Request Quote page and submitting the inquiry form.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <Header />

      {/* Banner */}
      <section className="faq_banner">
        <div className="container">
          <div className="faq_banner_content">
            <h1>Frequently Asked Questions</h1>
            <p>
              Find answers to common questions about our automotive
              glass products and services.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq_section">
        <div className="container">

          <div className="faq_title">
            <span>FAQ</span>
            <h2>Find Your Answers</h2>
          </div>

          <div className="faq_wrapper">

            {faqs.map((faq, index) => (
              <div
                className={`faq_item ${
                  activeIndex === index ? "active" : ""
                }`}
                key={index}
              >
                <div
                  className="faq_question"
                  onClick={() => toggleFAQ(index)}
                >
                  <h3>{faq.question}</h3>

                  <span>
                    {activeIndex === index ? "-" : "+"}
                  </span>
                </div>

                <div className="faq_answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQ;

